import { _selectSortedIds } from './_selectSortedIds'

export const selectMailboxIds = _selectSortedIds
